import { Avatar, Clickable, Icon, Row } from 'components';
import { useOutsideClick } from 'core';
import { theme } from 'lib';
import { useRef, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  flex-direction: row;
  align-items: center;
`;

const StyledInput = styled.input`
  width: 100%;
  font-family: CeraPro;
  margin: 12px 0;
`;

const CommentInput = (props) => {
  const [showEmojis, setShowEmojis] = useState(false),
    emojiRef = useRef(null),
    hasBody = props.value?.length;

  useOutsideClick(emojiRef, () => showEmojis && setShowEmojis(false));

  return (
    <Wrapper>
      <Row center ht="44px">
        <Avatar user={props.user} small />

        <Row
          pad="0 8px 0 16px"
          marg="0 0 0 12px"
          hasRadius="48px"
          hasBorder={`1px solid ${theme.GREY_50}`}
          wid="100%"
          between
          center
        >
          <StyledInput
            {...props}
            onSubmit={props.handleSend}
            ref={props.inputRef}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && hasBody) {
                props.handleSend();
              }
            }}
            value={props.value}
            placeholder="Your comment"
            placeholderTextColor={theme.GREY_60}
            placeholderStyle={{ fontSize: 16 }}
          />

          {!!props.value.length && (
            <Clickable onClick={props.handleSend}>
              <Row ht="24px" wid="24px" bg={theme.SECONDARY} hasRadius="24px" centerAll>
                <Icon type="send" col="#fff" dimensions={12} />
              </Row>
            </Clickable>
          )}
        </Row>
      </Row>
    </Wrapper>
  );
};

export default CommentInput;
